/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/DownloadAction/Empty"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 size="small"
 marginLeft={dtSpaceXxs}
 disabled={true}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Download"
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
 marginLeft={dtSpaceXxs}
>
{childProps => (
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
/>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}